import React, { useState, useContext } from "react";
import { useToast } from "../utils/useToast";
import GlobalToast from "../components/GlobalToast.jsx";
import { Helmet } from "react-helmet-async";
import { useSearchParams } from "react-router-dom";
import Api from "../utils/api";
import resetPasswordTranslations from "../locales/resetPasswordTranslations";
import { LanguageContext } from "../locales/LanguageContext";

const ResetPassword = () => {
  const { lang } = useContext(LanguageContext);
  const t = resetPasswordTranslations[lang] || {};
  const [searchParams] = useSearchParams();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [toast, showToast] = useToast();
  const [loading, setLoading] = useState(false);
  const token = searchParams.get("token");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newPassword || !confirmPassword) {
      showToast(t.fillFields, "error");
      return;
    }
    if (newPassword.length < 6) {
      showToast(t.minLength, "error");
      return;
    }
    if (newPassword !== confirmPassword) {
      showToast(t.mismatch, "error");
      return;
    }
    if (!token) {
      showToast(t.missingToken, "error");
      return;
    }
    setLoading(true);
    try {
      await Api.post("auth/reset-password", { token, newPassword });
      showToast(t.success, "success");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      showToast(err.message || t.error, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>{t.pageTitle} | AKAAL KIDS</title>
      </Helmet>
      <GlobalToast toast={toast} />
      <div
        style={{
          width: "100%",
          background: "linear-gradient(90deg, #f6815e 0%, #f6b93b 100%)",
          color: "#fff",
          padding: "38px 0 24px 0",
          textAlign: "center",
          marginBottom: 32,
          boxShadow: "0 4px 24px #f6815e22",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <h1
          style={{
            fontWeight: 900,
            fontSize: "2.6rem",
            letterSpacing: 1,
            marginBottom: 11,
            textShadow: "0 2px 12px #f6815e55",
          }}
        >
          {t.heroTitle}
        </h1>
        <div style={{ fontSize: 20, fontWeight: 500, opacity: 0.96 }}>
          <span role="img" aria-label="reset">
            🔄
          </span>{" "}
          {t.heroDesc}
        </div>
      </div>
      <div className="container py-5" style={{ maxWidth: 400 }}>
        <form
          onSubmit={handleSubmit}
          className="bg-white p-4 rounded shadow-sm"
        >
          <div className="mb-3">
            <input
              type="password"
              className="form-control"
              placeholder={t.newPasswordPlaceholder}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <input
              type="password"
              className="form-control"
              placeholder={t.confirmPasswordPlaceholder}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          {/* Snackbar/Toast messages handled globally */}
          <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={loading}
          >
            {loading ? t.resetting : t.resetBtn}
          </button>
        </form>
      </div>
    </>
  );
};

export default ResetPassword;
